import { useServicesQuery } from '@/services/api';

/**
 * Normalize legacy timezone values stored in the DB to valid IANA timezones.
 * "Eastern" is a legacy value that predates proper IANA timezone storage.
 */
export function normalizeTimezone(timezone: string): string {
  if (timezone === 'Eastern') return 'Etc/GMT+4';
  return timezone;
}

export function useWorkspaceTimezone(workspaceId: number) {
  const { data, isSuccess, isError } = useServicesQuery(
    'getWorkspaceSettings',
    { params: { environment_id: workspaceId } },
    { staleTime: 300_000, enabled: workspaceId > 0 },
  );
  const tz = data?.settings?.metrics_timezone;
  const resolved =
    tz != null && tz.length > 0 ? normalizeTimezone(tz) : Intl.DateTimeFormat().resolvedOptions().timeZone;
  return { tz: resolved, isReady: isSuccess || isError };
}
